import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// add matomo tracking
// import {useRecoilState, useRecoilValue} from "recoil";
// import {ShipmentMethod, SyliusShipmentTranslations} from '../Domain/Shipments';
// import {useHistory} from "react-router-dom";
// import { SpinnerButton } from  "./Ui/SpinnerButton/SpinnerButton";
// import {ShipmentInformationState, shipmentInformationState} from "../Domain/State/ShipmentState";
// import {Dropdown, DropdownOptions} from "./Ui/Dropdown/Dropdown";
// import {progressbarState} from "../Domain/State/ProgressbarState";
// import {orderValue, orderState} from "../Domain/State/OrderState";
// import ShipmentService from "../Domain/ShipmentService";
// import OrderService from "../Domain/Order";
//
// interface ShipmentInformation {
//     shipmentId: number
//     shipmentMethod: ShipmentMethod
//     translations: SyliusShipmentTranslations
// }
//
// interface ShipmentMethodNameToShipmentId {
//     [key: string]: number
// }
//
// interface ShipmentMethodInformation {
//     shipmentId: number
//     shipmentMethodCode: string
// }
//
// export default function ShipmentSelection() {
//     const history = useHistory();
//     history.push('/payment');
//     return (<></>);
//
//
//     const order = useRecoilValue(orderValue);
//     const orderRecoilState = useRecoilValue(orderState)
//     const [isLoading, setIsLoading] = useState(true);
//     const [switching, setSwitching] = useState(false);
//     const [shipmentOptions, setShipmentOptions] = useState([] as DropdownOptions[]);
//     const [selectedShipment, setSelectedShipment] = useState({} as ShipmentMethodInformation);
// eslint-disable-next-line max-len
//     const [shipmentInformation, setShipmentInformation] = useRecoilState<ShipmentInformationState>(shipmentInformationState);
//     const [, setProgressbarState] = useRecoilState(progressbarState);
//
//     useEffect(() => {
//         setProgressbarState(3);
//         if (shipmentInformation.selectedValue) {
//             setSelectedShipment({
//                 shipmentId: shipmentInformation.shipmentId,
//                 shipmentMethodCode: shipmentInformation.shipmentMethodCode
//             });
//         }
//         if (order?.checkoutState === 'shipping_skipped') {
//             history.push('/payment');
//             return;
//         }
//
//         if (shipmentInformation.selectedValue) {
//             setSelectedShipment({
//                 shipmentId: shipmentInformation.shipmentId,
//                 shipmentMethodCode: shipmentInformation.shipmentMethodCode
//             });
//         }
//
//         let methodNameToShipmentId: ShipmentMethodNameToShipmentId = {};
//         let promises = (order?.shipments ?? []).map(({id}) => {
//             return ShipmentService.getShipmentMethods(id);
//         });
//
//         Promise.all(promises)
//             .then(([methods]) => {
//                 methods.forEach((method) => {
//                     setShipmentOptions((prevState) => {
//                         return [...prevState,
//                             {
//                                 id: methodNameToShipmentId[method.name ?? 'key'],
//                                 method: method,
// eslint-disable-next-line max-len
//                                 translations: method.translations ?? {} as SyliusShipmentTranslations
//                             }
//                         ];
//                     });
//                 });
//             })
//             .finally(() => {
//                 setIsLoading(false);
//             });
//     }, [order, orderRecoilState])
//
//
//     function handleSelect(value: (((prevState: string) => string) | string)): void {
//         if (typeof value === "function") {
//             return;
//         }
// eslint-disable-next-line max-len
//         const shipmentId = parseInt(value.substring(value.indexOf('id') + 'id-'.length, value.indexOf('-method')));
// eslint-disable-next-line max-len
//         const shipmentMethodeCode = value.substring(value.indexOf('-method') + '-method-'.length);
//         setSelectedShipment({shipmentId: shipmentId, shipmentMethodCode: shipmentMethodeCode});
// eslint-disable-next-line max-len
//         setShipmentInformation({selectedValue: value, shipmentId: shipmentId, shipmentMethodCode: shipmentMethodeCode});
//     }
//
//     async function handleClick() {
//         if (order?.tokenValue) {
//             setSwitching(true);
// eslint-disable-next-line max-len
//             await OrderService.setShipmentMethod(order.tokenValue, selectedShipment.shipmentId, selectedShipment.shipmentMethodCode);
//             history.push("/payment");
//             setSwitching(false);
//         }
//     }
//
//     function handleBack() {
//         history.push('/address');
//     }
//
//     return (
//         <>
//             <div className="form-page">
//                 <div className="fields row">
//                     <div className="field field--text col col-12 col-md-12">
//                         <label>Shipment Methods</label>
//                         <div className="field__text"/>
//                     </div>
//                     {
//                         isLoading ? 'loading...' :
//                             <Dropdown fieldName="shipmentSelection"
//                                       label="Shipment Selection"
//                                       options={shipmentOptions}
//                                       value={shipmentInformation.selectedValue}
//                                       languageCode={'de_DE'}
//                                       required={true}
//                                       setSelectedValue={handleSelect}/>
//                     }
//                 </div>
//             </div>
//             <div className="actions">
//                 <nav className="form-navigation">
//                     <ul>
//                         <li className="previous">
// eslint-disable-next-line max-len
//                             <SpinnerButton caption="back" type="button" clickHandler={handleBack} isDisabled={switching}
//                                            secondary={true}/>
//                         </li>
//                         <li className="next">
//                             <SpinnerButton
//                                 type="button"
//                                 caption="next"
//                                 isLoading={switching}
// eslint-disable-next-line max-len
//                                 isDisabled={!selectedShipment.shipmentId && !selectedShipment.shipmentMethodCode}
//                                 clickHandler={handleClick}/>
//                         </li>
//                     </ul>
//                 </nav>
//             </div>
//         </>
//     )
// }
// We're skipping shipment for now
// @ts-ignore
export function ShipmentSelection() {
    return (_jsx(_Fragment, {}));
}
